import $ from 'jquery';
import debounce from 'lodash.debounce';
const enableBreadcrumbsFunctionality = () => {
    if ($('nav ol.breadcrumb').length === 0) {
        return;
    }
    /**
     * The breadcrumbs list.
     */
    const breadcrumbsList = $('ol.breadcrumb');
    /**
     * The "menu" breadcrumb.
     */
    const menuBreadcrumb = $('.breadcrumb-item.collapsed-breadcrumbs', breadcrumbsList);
    if (menuBreadcrumb.length === 0) {
        return;
    }
    /**
     * The intermediate breadcrumbs.
     */
    const intermediateBreadcrumbs = $('.breadcrumb-item:not(.active):not(.collapsed-breadcrumbs):not(:first-child)', breadcrumbsList);
    /**
     * The breadcrumbs.
     */
    const breadcrumbs = $('.breadcrumb-item:not(.collapsed-breadcrumbs)', breadcrumbsList);
    /**
     * Toggles the collapsed breadcrumbs menu after 3 seconds (debounced).
     */
    const debouncedToggleMenu = debounce(_toggleMenu, 500);
    // Toggle whether the menu is displayed
    _toggleMenu();
    $(window).on('resize', function (e) {
        debouncedToggleMenu();
    });
    const listObserver = new ResizeObserver(debouncedToggleMenu);
    listObserver.observe(breadcrumbsList[0]);
    /**
     * Toggles whether the collapsed breadcrumbs menu is displayed.
     */
    function _toggleMenu() {
        const fullWidth = breadcrumbs.toArray().reduce((accumulatedWidth, currentElement) => {
            return (accumulatedWidth + currentElement.getBoundingClientRect().width);
        }, 0);
        if (fullWidth >= (breadcrumbsList.width() || 0)) {
            menuBreadcrumb.css('display', 'flex');
            intermediateBreadcrumbs.addClass('hidden');
        }
        else {
            menuBreadcrumb.css('display', 'none');
            intermediateBreadcrumbs.removeClass('hidden');
        }
    }
};
export default enableBreadcrumbsFunctionality;
